import SubscriptionCardWrapper from './SubscriptionCardWrapper';

export default SubscriptionCardWrapper;
